// extracted by mini-css-extract-plugin
export var barContainer = "_4w-0";
export var extraThin = "_4w-3";
export var fillBar = "_4w-6";
export var fillContainer = "_4w-4";
export var overflow = "_4w-8";
export var overflowContainer = "_4w-5";
export var regular = "_4w-7";
export var thick = "_4w-1";
export var thin = "_4w-2";